// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EmptyCampaignsList_wrapper__5ArHk","inner":"EmptyCampaignsList_inner__RhB55","title":"EmptyCampaignsList_title__8tHbh","image":"EmptyCampaignsList_image__Kc2cR"};